import moment from "moment-timezone";
import colors from "vuetify/util/colors";

export function getChatStatus(vueComponent, object, chat) {
    if (object.status === "INFORMATION_REQUEST" && chat && chat.lastMessage) {
        const diff = moment(chat.lastMessage.createdAt).diff(moment(), "days");
        if (diff <= 0) {
            if (!chat.lastMessage.sender.company.accountingFirm) {
                object.chatStatus = vueComponent.$t("chat.responded", -diff, { diff: -diff });
                object.chatStatusColor = "green";
            } else {
                object.chatStatus = vueComponent.$t("chat.reminder", -diff, { diff: -diff });
                if (diff < 0) {
                    if (diff < -30) {
                        object.chatStatusColor = "red";
                    }
                    object.chatStatusColor = "orange";
                } else {
                    // if (diff >= 0) {
                    object.chatStatusColor = "blue";
                }
            }
        }
    }
}

export function showChatList(routeName) {
    if (!routeName) return false;
    if (routeName === "documents") return true;
    if (routeName === "bank") return true;
    if (routeName === "expenseReports") return true;
    // if (routeName === "document") return false
    // if (routeName === "expenseReport") return false
    // if (routeName.startsWith("reconciliation")) return false
    // if (routeName === "dashboard") return false
    // if (routeName === "generalLedger") return false
    return false;
}
